import React, {useContext, useMemo} from "react";
import './ProjectEconomicAnalysis.scoped.scss';
import DetailedProjectNavigation from "../DetailedProjectNavigation";
import ProjectDropdown from "../ProjectDropdown";
import {cn, resultIf} from "../../../../utils";
import {useMountAnimation, useWindowWidth} from "../hooks";
import {DetailedProjectContext} from "../DetailedProjectContext/DetailedProjectContext";
import DetailedProjectHtml from "../DetailedProjectHtml";
import ProjectInfoBlock from "../ProjectInfoBlock";
import ProjectInfoSection from "../ProjectInfoSection";
import {isSocialProject} from "../../../../utils/pages";
import {
  SecondaryProjectContext
} from "../../../../views/dashboard/lender/investment/purchase/SecondaryProjectContext/SecondaryProjectContext";
import SecondaryProjectNavigation
  from "../../../../views/dashboard/lender/investment/purchase/SecondaryProjectNavigation";

const ProjectEconomicAnalysis = () => {
  const project = useContext(DetailedProjectContext).project;
  const mounted = useMountAnimation();
  const isMobile = useWindowWidth();

  const isSocial = isSocialProject(project);
  const blocks = project.information?.content[0]?.blocks;

  const debtorInfo = useMemo(() => {
    if (!isSocial && project.information === null) return false;

    return <div className={cn("project-economic", resultIf(mounted, "mounted"))}>
      { isSocial
        ? project.infoSections.map((section, index) => <ProjectInfoSection key={index} {...section} />)
        : blocks
          ? blocks.map((block, index) => <ProjectInfoBlock key={index} {...block} />)
          : <DetailedProjectHtml translations={project.information.content} /> }
    </div>;
  }, [mounted]);

  const offer = !!useContext(SecondaryProjectContext);
  const navigation = useMemo(() => {
    if (offer) {
      return <SecondaryProjectNavigation />;
    }
    else {
      return <DetailedProjectNavigation />;
    }
  }, [offer]);
  return (
    <div className="project-economic-container">
      { isMobile ?
        <ProjectDropdown header="Экономический анализ">
          { debtorInfo }
        </ProjectDropdown>
        : <><div className="detailed-project__header">
          { navigation }
        </div>
        <div className="detailed-project__content">
          { debtorInfo }
        </div>
        </>}
    </div>
  );
};

export default ProjectEconomicAnalysis;